<template>
    <div id="Agreement">
       <div class="AgreementType1" v-if="$route.query.type == 1">
        <h1>和隆优化用户服务协议</h1>
        <div class="tit">和隆优化用户服务协议</div>
        <h4 class="h4text">
            为使用和隆优化的服务，您应当阅读并遵守本《和隆优化用户服务协议》（以下简称“本协议”）。本协议是用户与和隆优化之间的法律协议，是用户注册和隆优化账号并使用和隆优化平台服务或非经注册程序直接使用和隆优化平台服务时的通用条款。请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款。限制、免责条款可能以黑体加粗或加下划线的形式提示您重点注意。如果您不同意本协议的约定，您应立即停止注册程序或停止使用和隆优化平台服务；如您继续访问和使用和隆优化平台服务，即视为您已确知并完全同意本协议各项约定。
        </h4>
        <h4>一、定义</h4>
        <p>
            1、和隆优化平台，是指北京和隆优化科技股份有限公司及其关联公司旗下运营之和隆优化网站（www.yhkz.com)。
        </p>
        <p>
            2、用户，以下亦称为“您”，系指注册或登录和隆优化平台使用和隆优化产品或服务的具有完全民事权利能力和行为能力的企业法人、社会团体、自然人或其他社会组织等。按用户是否经过注册程序分为注册用户和非注册用户，注册用户是指通过和隆优化平台完成全部注册程序后，使用和隆优化平台服务或和隆优化网站资料的用户。非注册用户是指未进行注册、
        </p>
        <p>3、协议方，本协议中的协议方为和隆优化平台，统称“和隆优化”，您作为另一方。</p>
         <h4> 二、协议的效力 </h4>
         <h4 class="h4text">
            1、在您按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后或以其他和隆优化允许的方式实际使用和隆优化平台服务时，您即受本协议的约束。
         </h4>
         <h4 class="h4text">
            2、本协议内容包括本协议正文，您在使用和隆优化某一特定服务或系统时，该服务可能会另有单独的协议、相关业务规则、公告、帮助、说明、通用条款等（以下统称为“规则”）。所有和隆优化已经发布的或将来可能发布的规则均为本协议不可分割的组成部分，与本协议具有同等法律效力。除另行明确声明外，任何和隆优化及其关联公司提供的服务（以下称为“和隆优化平台服务”）均受本协议约束。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用和隆优化平台服务；如您继续访问和使用和隆优化平台服务，即视为您已确知并完全同意本协议各项内容。
         </h4>
         <h4>
         三、注册 
         </h4>
         <p>
            1、您确认，在您完成注册程序或以其他和隆优化允许的方式实际使用和隆优化平台服务时，您应当是具备相应民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的家长或法定监护人（以下统称"监护人"）应承担因此而导致的一切后果，且和隆优化有权注销您的账户，并向您及您的监护人索偿。
         </p>
         <p>2、和隆优化非常重视对青少年个人信息搜集和使用的安全性的保护。任何未满18周岁的未成年人参加网上活动应事先取得其监护人可经查证的同意并遵守《全国青少年网络文明公约》。监护人应承担未成年人网络活动风险及保护未成年人相关网络隐私的首要责任。 </p>
        <h4 class="h4text">
            3、在您签署本协议，完成注册程序时，和隆优化会向您提供唯一编号的和隆优化账户。您应对您的用户账户、登录密码、支付密码（如有）、验证码的安全以及对通过您的账户实施的行为负责，除非有法律规定或行政司法机关的指令，且征得和隆优化的同意，否则您的用户账户不得以任何方式转让、借用、赠与或继承（与账户相关的财产权益除外），您的登录密码、支付密码（如有）和验证码不得对任何第三方提供或泄露，否则，由此给您（或和隆优化、任何第三方）造成的一切损失，概由您自行承担（或者负责赔偿），和隆优化不承担任何责任。
        </h4>
        <p>4、如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即与和隆优化客服联系并通知和隆优化暂停或冻结相关服务。您理解和隆优化对您的请求采取行动需要合理时间，和隆优化对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</p>
        <h4>四、交易</h4>
        <h4 class="h4text">
            如您使用和隆优化提供的在线交易服务，您认可并自愿使用电子合同服务方式签署合同（或协议），接受并认可通过和隆优化平台签署的电子合同（或协议）与纸质合同（或协议）具备同等法律效力，接受并认可您电子签名与您手写签名具备同等法律效力。您同意并不可撤销地对乙方进行以下授权：
        </h4>
        <h4 class="h4text">
            1、 您向乙方申请开通第三方服务的（包括但不限于钱包服务、电子合同服务、个人履约信息服务、金融产品服务、第三方支付服务等），即视为您同意并授权我们将您的信息提供给与和隆优化合作的提供该等服务的第三方如理房通、和隆优化金服，您信息包括但不限于您向和隆优化提供的信息（如甲方向乙方提供的个人信息、征信信息以及甲方CA数字证书信息等）以及您在和隆优化平台录入的信息。 
        </h4>
        <h4 class="h4text">
            2、 授权和隆优化及其合作的第三方通过合法渠道查询或核实您的信息（法律、法规、监管政策禁止查询的除外）并有权基于您使用和隆优化的需要而保存、整理或加工查获的信息。和隆优化及其合作的第三方可依据前述信息持续性地向您提供相应服务（包括但不限于将信息用于向您推广、提供其他更加优质的产品或服务）。因您提供信息虚假或无效导致的一切法律责任由您承担。
        </h4>
        <h4 class="h4text">
            3、 授权和隆优化及提供电子合同服务的第三方根据您向和隆优化提供的资料开通电子合同服务（您需首先通过和隆优化及其合作的第三方对其进行的合法、有效的实名认证，且取得相应的CA数字证书），并生成电子印章。授权和隆优化及提供电子合同服务的第三方在您使用电子合同服务期间或在电子合同服务终止后，有权保留您在使用电子合同服务期间所形成的相关信息数据。
        </h4>
        <h4 class="h4text">
            4、 授权和隆优化以您名义开通第三方支付账户，支付您及其签约方签署的合同项下的相关款项，并向和隆优化支付其他服务费，和隆优化向您提供的收费服务，将在平台予以公示并由您自主选择。
        </h4>
        <h4 class="h4text">
            5、 您在和隆优化平台的账户、密码是我们识别您身份及指令的唯一标志，所有使用您账户、密码的操作（包括但不限于信息披露、信息发布、点击同意或提交各类规则协议、签署电子合同等）均为您或您的授权操作行为，任何使用您账户、密码发送至和隆优化或其合作的第三方的指令均构成您不可撤销的授权指示，和隆优化及其合作的第三方对于依照该指令进行的操作行为及其结果不承担任何责任。 
        </h4>
        <p>6、如您发现账号有任何异常操作，请及时联系我们的客服4008811519。</p>
            <h4>五、和隆优化平台服务使用规范 </h4>
            <p>1、通过和隆优化平台，您可以按照和隆优化的规则发布信息。但所发布之信息不得含有如下内容：</p>
            <p>1) 反对宪法所确定的基本原则，煽动抗拒、破坏宪法和法律、行政法规实施的；</p>
            <p>2) 煽动危害国家安全、泄露国家秘密、颠覆国家政权，推翻社会主义制度的；</p>
            <p>3) 煽动分裂国家、破坏国家统一、损害国家荣誉和民族利益的；</p>
            <p>4) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
            <p>5) 捏造或者歪曲事实，散布谣言，扰乱社会秩序的；</p>
            <p>6) 进行政治宣传或破坏国家宗教政策、宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；</p>
            <p>7) 公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；</p>
            <p>8) 损害国家机关信誉的；</p>
            <p>9) 其他违反宪法和法律法规的；</p>
            <p>2、在接受和隆优化平台服务的过程中，您不得从事下列行为：</p>
            <p>1）发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容，包含病毒、木马、定时炸弹等可能对和隆优化系统造成伤害或影响其稳定性的内容制造虚假身份以误导、欺骗他人；</p>
            <p>2）传送或散布以其他方式实现传送的含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，作为举例（但不限于此）：包括版权或商标法（或隐私权或公开权），除非用户拥有或控制着相应的权利或已得到所有必要的认可； </p>
            <p>3）使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用本“软件”获得的图像或相片的资料或信息；</p>
            <p>4）进行危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/帐号；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试本平台系统或网络的弱点或其它实施破坏网络安全的行为；企图干涉、破坏本平台系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；</p>
            <p>5）修改或伪造软件作品运行中的指令、数据、数据包，增加、删减、变动软件 的功能或运行效果，不得将用于上述用途的软件通过信息网络向公众传播或者运营；</p>
            <p>6）在未经和隆优化书面明确授权前提下，出售、出租、出借、散布、转移或转授权软件和服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益； </p>
            <p>7） 违背和隆优化页面公布之活动规则，包括但不限于发布虚假信息、作弊或通过其他手段进行虚假交易。</p>
            <p>3、您了解并同意，和隆优化有权应政府部门（包括司法及行政部门）的要求，向其提供您在和隆优化平台填写的注册信息和发布纪录等必要信息。 </p>
            <p>4、在和隆优化平台上使用和隆优化平台服务过程中，您承诺遵守以下约定：</p>
            <p>1)在使用和隆优化平台服务过程中实施的所有行为均遵守国家法律、法规等规范文件及和隆优化平台各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保和隆优化免于因此产生任何损失或增加费用。</p>
            <p>2)不发布国家禁止发布的信息（除非取得合法且足够的许可），不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息。</p>
            <p>3)不对和隆优化平台上的任何数据作商业性利用，包括但不限于在未经和隆优化事先书面同意的情况下，以复制、传播等任何方式使用和隆优化平台站上展示的资料。</p>
            <p>4)不使用任何装置、软件或例行程序干预或试图干预和隆优化平台的正常运作或正在和隆优化平台上进行的任何活动。您不得采取任何将导致不合理的庞大数据负载加诸和隆优化平台网络设备的行动。 </p>
            <p>5、您了解并同意：</p>
            <p>1)您违反上述承诺时，和隆优化有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知于您。 </p>
            <p>2)根据相关法令的指定或者和隆优化平台服务规则的判断，您的行为涉嫌违反法律法规的规定或违反本协议和/或规则的条款的，和隆优化有权采取相应措施，包括但不限于直接屏蔽、删除侵权信息、降低您的信用值或直接停止提供服务。</p>
            <p>3)对于您在和隆优化平台上实施的行为，包括您未在和隆优化平台上实施但已经对和隆优化平台及其用户产生影响的行为，和隆优化有权单方认定您行为的性质及是否构成对本协议和/或规则的违反，并据此采取相应的处理措施。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据承担不利后果。</p>
            <p>4)对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保和隆优化免于承担因此产生的损失或增加的费用。</p>
            <p>5)如您涉嫌违反有关法律或者本协议之规定，使和隆优化遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿和隆优化因此造成的损失及（或）发生的费用，包括合理的律师费用。</p>
            <h4>六、责任范围和责任限制 </h4>
            <p>1、和隆优化平台与其他的在线使用的互联网网站一样，也会受到各种不良信息、网络安全和网络故障问题的困扰，包括但不限于：</p>
            <p>1）其他用户可能会发布诈骗或虚假信息，或者发表有谩骂、诅咒、诋毁、攻击内容的等让人反感、厌恶的内容的非法言论；</p>
            <p>2）其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私权和/或其他合法权益的图片、照片、文字等资料； </p>
            <p>3）面临着诸如黑客攻击、计算机病毒困扰、系统崩溃、网络掉线、网速缓慢、程序漏洞等问题的困扰和威胁。 </p>
            <h4 class="h4text">
                您充分了解并同意：上述的各种不良信息、网络安全和网络故障问题，并不是和隆优化或者和隆优化平台所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，概由您自行承担，和隆优化无须向您承担任何责任。 
            </h4>
            <p>4、您同意，在发现本网站任何内容不符合法律规定，或不符合本用户协议规定的，您有义务及时通知和隆优化。如果您发现您的个人信息被盗用、您的版权或者其他权利被侵害，请将此情况告知和隆优化并同时提供如下信息和材料： 
</p>
            <p>1)侵犯您权利的信息的网址，编号或其他可以找到该信息的细节；</p>
            <p>2)您是所述的版权或者其他权利的合法拥有者的权利证明；</p>
            <p>3)您的个人信息及有效联系方式，包括真实姓名，身份证号、地址，电话号码和电子邮件等； </p>
            <p>4)您的身份证复印件、营业执照等其他相关资料。</p>
            <p>经审查得到证实的，我们将及时删除相关信息。我们仅接受邮寄、电子邮件或传真方式的书面侵权通知。情况紧急的，您可以通过客服电话先行告知，我们会视情况采取相应措施。 </p>
            <h4 class="h4text">
                5、您了解并同意，和隆优化不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿： 
            </h4>
            <p>1) 使用或未能使用和隆优化平台服务；</p>
            <p>2) 第三方未经批准地使用您的账户或更改您的数据；</p>
            <p>3) 通过和隆优化平台购买、获取任何服务、数据、信息等行为或替代行为或与其他任何第三方搭建线上/线下交易、服务法律关系之间的全部事宜产生的费用及损失；</p>
            <p>4) 您对和隆优化平台服务的误解；</p>
            <p>5) 因不可抗力或其他因非和隆优化的原因而引起的与和隆优化平台服务有关的其它损失。 </p>
            <h4 class="h4text">
                6、您在和隆优化上使用第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议及其他相关规则。和隆优化和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。 
            </h4>
            <h4 class="h4text">
                7、您同意在使用和隆优化平台服务过程中显示和隆优化自行或由第三方服务商向您发送或提供的推广或宣传信息、资讯、动态等（统称为推广信息，包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。除法律法规明确规定外，您应自行对依该推广信息进行的交易审慎评估理性接受，并对交易后果负责，对用户因依该推广信息进行的交易或前述第三方服务商提供的内容因而遭受的损失或损害，和隆优化不承担任何责任。
            </h4>
            <p>8、和隆优化对下列不可抗力行为免责：信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务。 
</p>
            <p>9、您应当严格遵守本协议及和隆优化规则等，因您违反协议或规则的行为给第三方或和隆优化造成损失的，您应当承担全部责任。 </p>
            <p>10、和隆优化保留在中华人民共和国大陆地区施行之法律允许的范围内独立决定拒绝服务、关闭用户账户、审查、编辑、清除用户发布内容或取消订单的权利。 </p>
            <h4>七、协议终止 </h4>
            <p>1、您同意，和隆优化基于平台服务的安全性，有权中止向您提供部分或全部和隆优化平台服务，暂时冻结您的账户，待安全问题解决后及时恢复，并对中止、冻结及恢复的事实及时通知。如果网站的安全问题是由于您的违法行为引起，和隆优化有权终止向您提供部分或全部和隆优化平台服务，永久冻结（注销）您的帐户，并有权向您对损失进行索赔。</p>
            <p>2、您同意，您与和隆优化的协议关系终止后，和隆优化仍享有下列权利： </p>
            <p>1) 按法律规定保存您在使用和隆优化服务期间的信息发布记录、交易记录及及其他登陆使用操作记录等。</p>
            <p>2）您在使用和隆优化平台服务期间存在违法行为或违反本协议和/或规则的行为的，和隆优化仍可依据本协议向您主张权利、追究责任。 </p>
            <h4>八、隐私权政策</h4>
            <p>1、和隆优化将在和隆优化平台公布并不时修订隐私权条款，隐私权条款构成本协议的有效组成部分。</p>
            <p>2、您知悉并认可：和隆优化可能会与第三方合作商向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本网站同等的保护用户隐私的责任，则您同意和隆优化有权将您的个人注册信息及注册资料等提供给该第三方。另外，在对您信息进行脱敏处理后，和隆优化有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。 
</p>
            <p>3、和隆优化将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。对此您表示理解和认同。 </p>
            <p>4、和隆优化不会将您的个人信息转移或披露给任何非关联的第三方，除非：</p>
            <p>1）相关法律法规或法院、政府机关要求；</p>
            <p>2）为完成合并、分立、收购或资产转让而转移；</p>
            <p>3）为提供您要求的服务所必需； </p>
            <p>4）为您提供任何您可能感兴趣的信息或服务。 </p>
            <p>5、您知悉并认可：和隆优化通过推广或其他方式向您提供链接，使您可以接入第三方服务或网站。您使用该等第三方的服务时，须受该第三方的服务条款及隐私政策约束，您需要仔细阅读其条款。本协议仅适用于和隆优化提供的服务器所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，和隆优化对任何第三方使用由您提供的信息不承担任何责任。 
</p>
            <p>6、您知悉并认可：为保护您的个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。对此您表示理解和认同。 
</p>
            <p>7、和隆优化不对用户所发布信息的删除或储存失败负责。和隆优化并不承诺对用户的存储信息进行无限期保留。</p>
            <p>8、当您终止使用和隆优化的服务注销和隆优化账号的，和隆优化将停止收集并使用您的个人信息。 </p>
            <p>9、关于用户个人信息的收集、存储、使用等事宜，具体可详见  <span style="color:#409eff;cursor: pointer;" @click="openAg">《和隆优化隐私权政策》</span>。 </p>
            <h4>八、知识产权声明 </h4>
            <p>1、和隆优化 为和隆优化所在公司及其关联公司的商标，受法律保护，任何人不得擅自使用。凡侵犯本公司版权等知识产权的，和隆优化将依法追究其相关法律责任。</p>
            <p>2、和隆优化平台所刊登的资料信息（包括但不限于编码、文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是和隆优化或其内容提供者的财产，受中国和国际版权法的保护。本平台上所有内容的汇编是和隆优化的排他财产，受中国和国际版权法的保护。本平台上所有软件都是和隆优化或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。任何被授权的浏览、复制、打印和传播属于和隆优化平台网站内信息内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此版权声明。</p>
            <p>3、用户一旦接受本协议，即表明该用户主动将其在任何时间段在本平台发表的任何形式的信息内容（包括但不限于用户问答、评价、用户咨询、各类资讯、知识、百科、意见、话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给和隆优化所有，用户同意和隆优化有权就任何主体侵权而单独提起诉讼。 </p>
            <p>4、本协议已经构成《中华人民共和国著作权法》及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在和隆优化平台上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</p>
            <p>5、用户同意并已充分了解本协议的条款，承诺不将已发表于和隆优化平台的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。 </p>
            <p>6、用户通过和隆优化平台发布的信息或内容，并不代表和隆优化之意见及观点，也不意味着和隆优化赞同其观点或证实其内容的真实性。</p>
            <h4 class="h4text">
                7、用户通过和隆优化平台发布的信息、文字、图片等资料均由和隆优化用户提供，其真实性、准确性和合法性由信息发布人负责。和隆优化不提供任何保证，并不承担任何法律责任。如果以上资料侵犯了第三方的知识产权或其他权利，责任由信息发布者本人承担，和隆优化对此不承担责任。 
            </h4>
            <h4 class="h4text">
                8、除法律另有强制性规定外，未经和隆优化明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、传播、展示、镜像、上载、下载、转载、引用、链接、抓取或以其他方式使用和隆优化平台的信息内容及相关资料，否则，和隆优化有权追究其法律责任。
            </h4>
            <p>9、和隆优化平台以下内容不可任意转载：</p>
            <p>1）本平台内发布的所有信息；</p>
            <p>2）已作出不得转载或未经许可不得转载声明的内容；</p>
            <p>3）本平台中特有的图形、标志、页面风格、编排方式、程序等；</p>
            <p>4）本平台中必须具有特别授权或具有注册用户资格方可知晓的内容；</p>
            <p>5）其他法律不允许或本平台认为不适合转载的内容。 </p>
            <p>10、对于不当引用和隆优化网站内容而引起的纷争等或因纠纷等造成的任何损失，和隆优化不承担相关法律责任。对不遵守本声明的用户或其他违法、恶意使用和隆优化平台内容者，和隆优化保留追究其法律责任的权利。</p>
            <p>九、法律适用、管辖与其他 </p>
            <p>1、本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律，如法律无相关规定的，则应参照通用国际商业惯例和（或）行业惯例。</p>
            <p>2、本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
            <h4 class="h4text">
                3、因本协议产生之争议、纠纷，应由和隆优化与您友好协商解决；协商不成的，任何一方均有权向当地人民法院诉讼解决。 
            </h4>
            <h4 class="h4text">
                为给您提供更好的服务以及随着国家法律法规的调整、和隆优化业务的发展，本协议也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在和隆优化网站、和隆优化移动端上发出更新版本并在生效前通过适当方式提醒您相关内容的更新，也请您访问和隆优化以便及时了解最新的隐私政策 
            </h4>
            <h4 class="h4text">
                为维护网民和相关权利人利益，北京和隆优化科技有限公司已经以公示的方式，为用户及相关权利人提供了丰富、便捷的线上线下投诉渠道。基于网络用户间的公平考量，同时也为了使网络用户的投诉能够及时得到处理，避免被当做垃圾邮件屏蔽，北京和隆优化科技有限公司拒绝接收和处理所有以电子邮件形式发送给本公司员工个人的网络侵权通知，更不承诺对发送给本公司员工个人的电子邮件侵权通知进行优先处理，特此告知 
            </h4>
            <p style="text-indent:20px">本协议自  2022   年    11  月    01  日生效。 </p>
            <h4 class="h4text">本协议内容中以加粗方式显著标识的条款，请您着重阅读。您点击“立即注册”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。</h4>
       </div>
           <div class="AgreementType1" v-if="$route.query.type == 2">
             <h1>《“和隆优化”隐私政策》</h1>
             <div class="tit1">
                尊敬的“和隆优化”用户：和隆优化平台或和隆优化（北京和隆优化科技有限公司及其关联公司，以下亦称 <strong>“和隆优化”</strong> 或 <strong>“我们”</strong>）非常重视客户个人信息及隐私权的保护，因此我们制订了涵盖如何收集、存储、使用、共享和保护客户信息的隐私政策。<strong>为《“和隆优化”隐私政策》（以下简称本“隐私政策”）之目的，和隆优化系指包含工业优化控制服务、软件服务。</strong> 
             </div>
             <h4 class="h4text">
                请仔细阅读本隐私政策的全部条款（尤其是以加粗方式显示的内容），确认您已完全了解我们对您个人信息的处理规则，并作出您认为适当的选择。阅读过程中，如您有任何疑问，可联系我们的客服（电话:4008811519 ）咨询，如您不同意协议中的任何条款，您应立即停止访问或使用和隆优化平台。
             </h4>
             <h4 class="h4text">
                如您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品和/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。
             </h4>
             <h4>本隐私政策将帮助您了解以下内容：</h4>
             <h4>一、信息的收集和使用</h4>
             <p>个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息；个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。</p>
            <p> <strong>为本隐私政策之目的，个人信息包括但不限于（其中，个人敏感信息以加粗方式显示）</strong> ：基本信息（包括个人姓名、生日、性别、住址、 <strong>个人电话号码、手机号码、电子邮箱</strong> ）；<strong>个人身份信息（包括身份证、军官证、护照、驾驶证等）；面部特征；</strong> 网络身份标识信息（包括 <strong>电子签名、系统账户、账户名、账户昵称、</strong> IP地址、<strong>邮箱地址及与前述有关的密码、口令、口令保护答案）；个人财产信息（房产信息、房源交易信息、房源租赁信息、交易记录、交易账户等虚拟财产信息）；</strong> 其他信息（包括通讯录、<strong>个人电话号码、</strong> 行程信息、<strong>网页浏览记录、住宿信息、精准定位信息</strong> ）。
</p>
            <p>我们仅会出于以下目的，收集和使用您的个人信息：</p>
            <h4>（一）您须授权我们收集和使用您个人信息的情形</h4>
            <p>
                我们的产品和/或服务包括一些核心功能，这些功能包含了实现信息搜索、和隆优化平台相关在线交易及支付所必须的功能。
                <strong>我们需要收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品和/或服务。这些功能包括：</strong>
            </p>
            <h4>1、实现信息搜索或交易相关所必须的功能</h4>
            <h4>（1）用户注册</h4>
            <p>
                <strong>当您注册成为和隆优化用户时，您需要至少向我们提供您准备使用的账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。</strong>
                您的账户名为您的默认昵称，您可以修改补充您的昵称、性别、生日、兴趣爱好以及您的实名验证相关信息（包括姓名、
                <strong>身份证、面部特征</strong>
                等），这些信息均属于您的“账户信息”。您补充提供的账户信息将有助于我们为您提供个性化的信息服务，其中实名验证的相关信息还将被用于交易相关的功能和服务，如果您不提供这些补充信息，我们将可能不能向您推荐个性化的信息，或处于保障交易安全的考虑，我们可能不能向您提供相关的交易服务，但不会影响您使用的基本功能。
            </p>
            <h4>（2）线上交易及支付</h4>
            <p>当您通过和隆优化平台或和隆优化其他线上交易平台进行线上交易时，我们将使用您的个人身份证件、面部识别信息来实现身份核验、使用您的手机号码、安全验证码信息来实现交易确认、使用您的银行账户或第三方账户信息以保障您的支付安全、我们会使用您的交易订单信息为您查询订单以及提供客服咨询与售后服务；我们还会使用您的信息来判断您的交易是否存在异常以保护您的交易安全。</p>
            <p>在您下单后，您可以选择与和隆优化合作的第三方支付机构（包括支付宝、微信支付、京东支付及银联、网联等支付通道，以下称 <strong>“支付机构”</strong> ）所提供的支付服务。第三方支付机构的支付服务本身并不收集您的个人信息，但我们需要将您的和隆优化平台订单号与交易金额信息与这些支付机构共享以实现其确认您的支付指令并完成支付。
</p>
            <h4>（4）客户服务</h4>
            <p>当您需要我们提供客户服务时，我们的客服（包括呼叫中心及在线客服）会使用您的相关信息，账户信息和订单信息。</p>
            <p>为保证您的账户安全，我们的呼叫中心客服和在线客服会使用您的账户信息对您的身份进行核验。待您的身份核验后，我们将会查询您的订单信息。您有可能会在与我们的客服人员沟通时，提供给出上述信息外的其他信息，如当您要求我们变更配送地址、联系人或联系电话。
</p>
            <p>为保障您的合法权益，保证我们的客户服务合法合规，并持续改进我们的客服能力，我们会对您与客服沟通的过程进行录音或文字留存，该留存信息仅会在法律所允许的期限和范围内予以留存和处理，并仅在基于您的维权需要、政府部门及司法部门的调查指令需要提供时，我们会进行必要披露。
</p>
            <h4>2、保障交易安全所必须的功能</h4>
            <p>为提高您使用我们的产品与/或服务时系统的安全性，更准确地预防钓鱼网站欺诈和保护账户安全，我们可能会通过了解您的订单信息、设备信息（如设备型号、设备识别码、设备标识符）、您的网络使用习惯（如浏览信息、常用软件信息）等手段来判断您的账户风险，并可能会记录一些我们认为有风险的链接（“URL”）；我们也会收集您的设备信息对于和隆优化系统问题进行分析、统计流量并排查可能存在的风险、在您选择向我们发送异常信息时予以排查。
</p>
            <h4>（二）您可选择是否授权我们收集和使用您的个人信息的情形</h4>
            <p>
                1、为使您使用和隆优化平台更便捷或更有乐趣，从而提升您在和隆优化的体验，我们的以下附加功能中可能会收集和使用您的个人信息。
                <strong>如果您不提供这些个人信息，您依然可以使用和隆优化的产品或服务中的核心功能，但您可能无法使用这些可以为您所带来更多乐趣的附加功能或在使用某些产品或服务时需要重复填写一些信息。</strong>
                这些附加功能包括：
            </p>
            <p>
                1）个性化推荐功能
                <strong>我们可能会收集您的订单信息、浏览信息、您设备的位置信息、您向和隆优化提供的兴趣爱好进行数据分析以形成用户画像，用来将您感兴趣的产品或服务信息展示给您；或在您搜索时向您展示您可能希望找到的服务。例如，我们会收集您的位置信息来判断您所处的地点，自动为您推荐您所在区域可以浏览的房源、可购买的商品或服务，或向您推荐离您周边的资产投资等服务。</strong>
            </p>
            <p style="background:yellow">
                （2）基于摄像头（相机）的附加功能：您可以使用这个附加功能完成视频拍摄、拍照、扫码以及人脸识别登录的功能。当您使用和隆优化在线交易服务时，我们需要收集您的面部特征信息。我们可能会将人脸识别技术应用于更多场景，届时我们会再次与您确认您是否愿意我们使用您的面部信息来实现这些附加功能。
            </p>
            <p>
                （4）基于语音技术的附加功能：您可以直接使用麦克风来与我们的客服机器人进行咨询和互动。
                <strong>在这些功能中我们会处理您的录音内容，以识别您需求和客服与售后需求。</strong>
            </p>
            <p>（5）基于通讯录信息的附加功能：
                <strong>在获得您授权同意的前提下，我们将收集您的通讯录信息，以方便您在使用和隆优化平台服务时不再手动输入您通讯录中联系人的信息；</strong>
                为了增加您在和隆优化的社交乐趣，在获得您的同意后我们也可以判断您的联系人是否也同为和隆优化用户，并在和隆优化平台上为你们的交流提供便利。
            </p>
            <p>（6）改进我们的产品与/或服务：为了提供服务及改进服务质量的合理需要，我们可能会获得的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间进行互动时授权我们获得的相关信息。2、上述附加功能可能需要您在您的设备中向我们开启您的地理位置（位置信息）、相机（摄像头）、相册（图片库）、麦克风以及通讯录的访问权限，以实现这些功能所涉及的信息的收集和使用。您可以在和隆优化平台通过“账户设置—设置—隐私”中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。
                <strong>请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。</strong>
            </p>
            <h4>（三）您充分知晓，以下情形中，我们收集、使用个人信息可能无需征得您的授权同意：</h4>
            <p>
                <strong>1、与国家安全、国防安全直接相关的；</strong>
            </p>
            <p>
                <strong>2、与公共安全、公共卫生、重大公共利益直接相关的；</strong>
            </p>
            <p>
                <strong>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</strong>
            </p>
            <p>
                <strong>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</strong>
            </p>
            <p>
                <strong>5、所收集的个人信息是您自行向社会公众公开的；</strong>
            </p>
            <p>
                <strong>6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</strong>
            </p>
            <p>
                <strong>7、根据您的要求签订和履行合同所必需的；</strong>
            </p>
            <p><strong>8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；</strong></p>
            <p> <strong>9、法律法规规定的其他情形。</strong></p>
            <h4>
                （四）我们从第三方获得您个人信息的情形
            </h4>
            <p>
                我们可能从第三方获取您授权共享的账户信息（头像、昵称），并在您同意本隐私政策后将您的第三方账户与您的和隆优化账户绑定，使您可以通过第三方账户直接登录并使用我们的产品与/或服务。我们会将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。
            </p>
            <h4>（五）您个人信息使用的规则</h4>
            <p>1、我们会根据本隐私政策的约定，在实现我们的产品与/或服务功能所必要的范围内，对所收集的个人信息进行使用。</p>
            <p>
                2、在收集您的个人信息后，我们可能将通过技术手段对部分数据进行匿名化处理，匿名化处理的信息将无法识别主体。
                <strong>请您了解并同意，在此情况下我们有权使用已经匿名化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。</strong>
            </p>
            <h4 class="h4text">
                3、请您注意，您在使用我们的产品与/或服务时所提供的所有个人信息，除非您删除、通过系统设置或联系我们等方式撤回您的同意，否则将在您使用我们的产品与/或服务期间持续授权我们使用。在您注销账户时，我们将停止使用并删除您的个人信息。
            </h4>
            <p>4、我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</p>
            <p>5、当我们展示您的个人信息时，我们会采用包括内容替换、去标识化处理等方式对您的信息进行脱敏，以保护您的信息安全。</p>
            <p>6、当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会要求您通过主动勾选的形式事先征求您的同意。</p>
            <h4>二、我们如何共享、转让、公开披露您的个人信息</h4>
            <h4>（一）共享</h4>
            <h4>1、我们不会与和隆优化以外的任何公司、组织和个人共享您的个人信息，但以下情况除外：</h4>
            <p><strong>（1）事先获得您明确的同意或授权；</strong></p>
            <p><strong>（2）与国家安全、国防安全直接相关的；</strong></p>
            <p><strong>（3）与公共安全、公共卫生、重大公共利益直接相关的；</strong></p>
            <p><strong>（4）与犯罪侦查、起诉、审判和判决执行等直接相关的；</strong></p>
            <p><strong>（5）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</strong></p>
            <p><strong>（6）自行向社会公众公开的个人信息；</strong></p>
            <p><strong>（7）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</strong></p>
            <h4 class="h4text">
                2、我们可能会将您的个人信息与我们的关联方共享。但我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束，如我们会向和隆优化品牌商提供个人交易信息、个人信用信息以保证用户可以顺利使用和隆优化品牌商提供的其他服务。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。
            </h4>
            <h4 class="h4text">3、我们可能会向合作伙伴等第三方共享您的订单信息、账户信息、设备信息以及位置信息，以保障为您提供的服务顺利完成。但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。
</h4>
            <p> 我们的合作伙伴包括以下类型：</p>
            <p>（1）商品或技术服务的供应商。
                <strong>
                    我们可能会将您的个人信息共享给支持我们功能的第三方。
                </strong>
                这些支持包括为我们的提供授权房源、供货或提供基础设施技术服务、物流配送服务、支付服务、数据处理等。我们共享这些信息的目的是可以实现我们的核心功能，比如我们必须与物流服务提供商共享您的订单信息才能安排送货；或者我们需要将您的订单号和订单金额与第三方支付机构共享以实现其确认您的支付指令并完成支付等。
            </p>
            <p>就上述第三方向您提供的服务，我们对该等第三方提供的服务性质与质量不作任何承诺或承担任何责任，对该等第三方进行的用户信息采集和处理行为也不作任何承诺或承担任何责任。有关您在使用第三方服务中相关的隐私控制和选项，以及服务提供者的隐私规定，请您谨慎参阅该等第三方所提供的隐私政策。
</p>
            <p>
                （3）委托我们进行推广的合作伙伴。有时我们会代表其他企业向使用我们产品与/或服务的用户群提供促销推广的服务。
                <strong>
                    我们可能会使用您的个人信息以及您的非个人信息集合形成的间接用户画像与委托我们进行推广的合作伙伴（“委托方”）共享，但我们仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您个人。
                </strong>
                比如我们可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。
            </p>
            <p>4、对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明以及其他任何相关的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。
</p>
            <p>5、为了遵守法律、执行或适用我们的使用条件和其他协议，或者为了保护和隆优化、您或其他和隆优化客户的权利及其财产或安全，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息，比如为了确认您的履约能力，我们会向第三方征信机构提供您的身份证件信息以获取您在征信机构的个人信用。前述共享行为并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。
</p>
            <h4>（二）转让与公开披露</h4>
            <h4 class="h4text">
                在涉及合并、收购、资产转让或类似的交易时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
            </h4>
            <p>除本隐私政策所明确述明的情况以外，我们不会将您的个人信息转让或公开披露给任何公司、组织和个人，但以下情况除外：</p>
            <p>1、与国家安全、国防安全直接相关的；</p>
            <p>2、与公共安全、公共卫生、重大公共利益直接相关的；</p>
            <p>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
            <p>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
            <p>5、您向社会公众公开的个人信息；</p>
            <p>6、从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开等渠道。</p>
            <h4>四、我们如何保护和保存您的个人信息</h4>
            <h4>（一）我们保护您个人信息的技术与措施</h4>
            <p>我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：</p>
            <p>我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。</p>
            <p>和隆优化采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离。在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换在内多种数据脱敏技术增强个人信息在使用中安全性。和隆优化采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
</p>
            <p>和隆优化采用代码安全自动检查、数据访问日志分析技术进行个人信息安全审计。</p>
            <p>和隆优化通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。</p>
            <p>和隆优化通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。</p>
            <p>加强安全意识。我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
            <p>3、我们仅允许有必要知晓这些信息的和隆优化及和隆优化关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与和隆优化的合作关系。</p>
            <p>4、我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本隐私政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
            <p>5、我们建议您使用电子邮件、即时通讯、社交软件等与其他用户的交流工具时请使用复杂密码，并注意保护您的个人信息安全。</p>
            <p>6、互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
            <p>7、安全事件处置</p>
            <p>在通过和隆优化与第三方进行网上商品或服务的交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址等。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。
</p>
            <p>为应对个人信息泄露、损毁和丢失等可能出现的风险，和隆优化制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。和隆优化也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
</p>
            <p>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。
</p>
            <p>
                8、如果您对我们的个人信息保护有任何疑问，可通过本隐私政策最下方约定的联系方式联系我们。
                <strong>如您发现自己的个人信息泄密或我们存在有安全弱点、可疑安全事件时，尤其是您的账户及密码发生泄露，请您立即通过本隐私政策最下方约定的联系方式联络我们，以便我们采取相应措施，禁止私自尝试或验证弱点。</strong>
            </p>
            <h4>（二）您个人信息的保存</h4>
            <p>1、原则上，您的个人信息将会被存储于中华人民共和国境内。如您使用跨境交易服务，且需要向境外传输您的个人信息完成交易的，或基于其他必要的业务需要确需将您的个人信息传输至境外，我们会单独征得您的授权同意并要求接收方按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理这些个人信息。
</p>
            <p>2、当您成功申请注销和隆优化账户后，我们将在您提出申请的48小时内完成对您的账户注销审核，审核通过后，我们将对您的个人信息进行删除或匿名化处理。
</p>
            <p>
                <strong>3、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
</strong>
            </p>
            <h4>五、您如何管理您的个人信息</h4>
            <p>和隆优化非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>
            <p>1、访问和更正您的个人信息</p>
            <p>除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：</p>
            <p style="background:yellow">
                （1）您的账户信息：PC端您可以在“我的和隆优化”页面的“编辑资料”菜单中查阅您提交给和隆优化的所有个人信息，你也可通过上述途径更新除实名认证信息之外的其他个人信息（您的实名认证信息是您通过实名认证时使用的姓名和身份证信息），如您需要变更您的实名认证信息，您可拨打      服务热线申请变更。移动端APP具体路径为：账户名称、个人资料信息：首页--“我的”进入我的和隆优化-点击头像进入账户设置；账户密码、电话号码、安全信息：首页--“我的”进入我的和隆优化--点击头像进入账户设置。
            </p>
            <p style="background:yellow">（2）您的浏览信息：您可以访问或清除您的搜索历史记录、查看和修改兴趣以及管理其他数据。移动端APP路径为：搜索历史记录：首页--“我的”进入我的和隆优化—搜索条件；关注及其他数据：首页--“我的”进入我的和隆优化-。
</p>
            <p style="background:yellow">（3）您的评论信息：PC端您可以访问或更新或清除您的个人评论，移动端APP路径为：我的—        --评价。
</p>
            <p style="background:yellow">（4）对于您在使用我们的产品与/或服务过程中产生的其他个人信息需要访问或更正，请随时联系我们。我们会根据本隐私政策所列明的方式和期限响应您的请求。
</p>
            <p style="background:yellow">（5）您无法访问和更正的个人信息：除上述列明的信息外，考虑到不响应请求可能给您合法权益带来的风险和损害、技术可行性及实现请求成本等因素，您的部分个人信息我们还无法为您提供访问和更正的服务，这些信息主要是为了提升您的用户体验和保证交易安全所收集的您的设备信息、您使用附加功能时产生的个人信息。上述信息我们会在您的授权范围内进行使用，您无法访问和更正，但您可联系我们进行删除或做匿名化处理。
</p>
            <h4>2、删除您的个人信息</h4>
            <p>您在我们的产品与/或服务页面中可以直接清除或删除的信息，包括浏览记录、订单信息、收货地址信息；</p>
            <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
            <p>（1）如果我们处理个人信息的行为违反法律法规；</p>
            <p>（2）如果我们收集、使用您的个人信息，却未征得您的同意；</p>
            <p>（3）如果我们处理个人信息的行为违反了与您的约定；</p>
            <p>（4）如果您注销了和隆优化账户；</p>
            <p>（5）如果我们终止服务及运营。</p>
            <p>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
</p>
            <h4>3、改变您授权同意的范围或撤回您的授权</h4>
            <h4 class="h4text">
                您可以通过删除信息、关闭设备功能、在和隆优化网站或软件中进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账户的方式，撤回我们继续收集、处理您个人信息的全部授权。
            </h4>
            <h4 class="h4text">
                请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
            </h4>
            <h4>4、注销账户</h4>
            <p>
                您可以我们的APP端个人中心--我的个人信息—注销账号申请注销账户。您注销账户后，我们将停止为您提供产品与/或服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。
            </p>
            <p>您的账户一旦注销，将面临如下风险及问题</p>
            <p  style="background:yellow">您的账户一旦注销，将面临如下风险及问题（1）账户在系统中尚有资产或虚拟权益（包括但不限于账户余额、虚拟货币、优惠券等）且您在申请账户注销前未予处理的，将归和隆优化所有；</p>
            <p>（2）账户内未完成的订单、服务会因您账户注销而无法继续执行，如您已完成支付义务，已支付的权益有可能无法返还；</p>
            <p>（3）如您的账户因违法违规操作或侵犯他人合法权益导致处罚或纠纷，我们将在必要的期限内保留处理此纠纷、投诉所必要的信息，并在该等期限届满后对相关个人信息进行删除或匿名化处理；</p>
            <h4>
                5、如果您不想接受我们给您发送的促销信息，您随时可通过以下方式取消：
            </h4>
            <p>（1）您可通过PC端账户设置页面的邮件订阅菜单中取消邮件订阅的促销信息。</p>
            <p>（2）您可以随时回复“TD”来取消我们给您发送的手机促销短信。</p>
            <p>（3）您可以通过移动端APP“账户设置-设置-推送消息设置-通知”设置是否接受我们通过“通知”推动给您的商品和促销信息</p>
            <p>（4）您可以通过移动端APP“账户设置-我们的定制”或“账户设置页设置是否接受您可能感兴趣或关注的服务的问答信息和用户的互动信息。</p>
            <p>（5）我们会与第三方的平台或媒体（“平台”）合作基于您的个人信息向您推荐个性化的商品或服务。这些个人信息包括诸如在本网站的产品与/或服务的使用情况、访问本网站关联公司网站的情况及您在您的账户设置中填写的兴趣爱好。平台仅向我们提供了展示商品的窗口，窗口内容的链接是和隆优化站内的个性化商品展示信息，由和隆优化进行管理，因此我们不会向广告商提供您的任何的个人信息。而且我们在推荐窗内设置了屏蔽功能，您可选择屏蔽您不喜欢的广告。如您不愿意接受和隆优化在单个平台上的推荐服务，请联系平台进行关闭。您知晓并理解平台是自主经营的实体，和隆优化无法对其进行管理。</p>
            <p>（6）为了保护您的隐私，我们不会以任何方式和途径向您推送涉及宗教信仰、性、疾病等相关敏感内容的促销或商品信息给您。</p>
            <h4>6、响应您的请求</h4>
            <p>如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为和隆优化存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以发送电子邮件942451825@qq.com或通过本协议下方的其他方式与我们联系。
</p>
            <p>为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的30天内答复您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
</p>
            <h4>在以下情形中，按照法律法规要求，我们将可能无法响应您的请求：</h4>
            <p><strong>在以下情形中，按照法律法规要求，我们将可能无法响应您的请求：</strong></p>
            <p><strong>（2）与公共安全、公共卫生、重大公共利益直接相关的；</strong></p>
            <p><strong>（3）与犯罪侦查、起诉、审判和执行判决等直接相关的；</strong></p>
            <p><strong>（4）有充分证据表明您存在主观恶意或滥用权利的；</strong></p>
            <p><strong>（5）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</strong></p>
            <p><strong>（6）涉及商业秘密的。</strong></p>
            <h4>六、未成年人的个人信息保护</h4>
            <p>
                1、和隆优化非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您家长或法定监护人的书面同意。和隆优化根据国家相关法律法规的规定保护未成年人的个人信息。
            </p>
            <p>2、对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
</p>
            <p>3、如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>
            <h4>七、通知和修订</h4>
            <p>1、为给您提供更好的服务以及随着和隆优化业务的发展，本隐私政策也会随之更新。但未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。我们会通过在和隆优化网站、和隆优化移动端APP上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问和隆优化以便及时了解最新的隐私政策。
</p>
            <p>2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</p>
            <h4>本隐私政策所指的重大变更包括但不限于：</h4>
            <p><strong>（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</strong></p>
            <p><strong>（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等</strong></p>
            <p><strong>（3）个人信息共享、转让或公开披露的主要对象发生变化；</strong></p>
            <p><strong>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</strong></p>
            <p><strong>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</strong></p>
            <p><strong>（6）个人信息安全影响评估报告表明存在高风险时。</strong></p>
            <p>3、我们还会将本策略的旧版本存档，供您查阅。</p>
            <h4>3、我们还会将本策略的旧版本存档，供您查阅。</h4>
            <p>1、如您对本隐私政策或您个人信息的相关事宜有任何问题、意见或建议，请通过发送邮件至942451825@qq.com或拨打我们的客服电话4008811519等多种方式与我们联系。</p>
            <p>2、我们设立了个人信息保护专职部门（或个人信息保护专员），您可以通过发送邮件至942451825@qq.com或拨打电话4008811519的方式与其联系。</p>
            <p>3、一般情况下，我们将在三十天内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报，或者向有管辖权的法院提起诉讼。
</p>
            <h4 class="h4text">
                我们谨此再次提醒您，本协议内容中以加粗方式显著标识的条款，请您着重阅读。您点击“立即注册”按钮即视为您完全接受本协议，在点击之前请您再次确认已知悉并完全理解本协议的全部内容。
            </h4>
           </div>
           <div class="AgreementType1" v-if="$route.query.type == 3">
             <h1>《“和隆优化”付费服务条款》</h1>
              <h4>和隆优化软件服务付费版服务条款</h4>
              <h4>更新日期：2023 年 01 月 03 日 </h4>
              <h4>生效日期：2023 年 01 月 03 日 </h4>
              <div class="tit1" style="padding-bottom:10px">
               和隆优化是由北京和隆优化科技股份有限公司及/或其关联方（以下简称“和隆优化”，或“我们”）提供的互联网软件服务（以下简称“软件服务”）。本服务条款（以下简 称“本条款”）是您（以下简称“您”或“用户”）与和隆优化之间关于您访问和使用和隆优化软件服务付费版及其他付费服务（以下简称“软件付费服务”或“本服务”）的协议。
             </div>
             <div class="tit1" style="padding-bottom:10px">
                在本服务创建账户并使用之前，您必须首先同意本条款。<strong>在接受本条款之前</strong> ，请 您仔细阅读全部内容，如您无法准确理解或不同意本条款的任一内容，请不要访问使用和隆优化软件付费服务。
                <strong>您通过网络页面点击确认、实际购买或使用本服务等操作均表示您已阅读并充分理解本协议之内容，与和隆优化就使用或订购相应产品和/或服务已达成合意，并同意接受本条款的全部约定内容，受其约束。 特别提示您关注本条款关于限制、免除和隆优化责任的条款、对用户的权利限制条款、违规/违约行为的认定处理、以及管辖法院的选择</strong>
                等条款内容，前述条款可能以加粗及/或加下划线形式提示您注意。
             </div>
             <div class="tit1">
                您同意和隆优化有权不时地对本条款进行修订，且毋须另行通知。修订后的条款一旦在网页上公布即有效代替原来的服务条款。您继续访问和使用和隆优化软件付费服务，
                即视为您接受修订后的服务条款。否则，您有权通过停止访问和隆优化软件服务且拒绝使用服务、删除您在和隆优化软件上的信息和账户等方式来终止服务条款。 
                如果您代表某个机构而非您个人注册、登录和使用和隆优化软件服务，则您将被认为获得充分授权代表该机构同意本服务条款以及服务条款不时的修改和补充。
             </div>
             <h4>
                一、服务内容
             </h4>
             <p>
                <strong>1.1</strong>  本条款中的“软件服务”指：和隆优化向您提供 www.yhkz.com 网站（即和隆优化 官网）上所展示的产品和服务，包括但不限于通过网页、移动端 APP 等方式提供的全部服务，具体服务内容以您所使用或订购的内容为准。“和隆优化软件付 费服务”是指和隆优化软件付费版及其他付费服务。
             </p>
             <p>
                <strong>1.2</strong> 根据实际需要和和隆优化不时提供的其他服务内容，和隆优化可能与您另行签订其他协议。同时，即使未另行签订其他协议，您使用和隆优化软件的具体服务也 将被视为您同意和隆优化关于该等具体服务的任何要求。如果其他协议和本 条款之间存在冲突，应以其他协议为准，但以该冲突和与该协议特定事宜相关为限。
             </p>
             <p>
               <strong> 1.3</strong> 和隆优化保留随时变更、中止或终止部分免费服务的权利，并保留根据实际情况随时调整和隆优化软件服务提供的免费服务种类、形式的权利。<strong>和隆优化不承担因和隆优化软件服务提供的任何免费服务的调整给您造成的损失</strong> 。和隆优化有权在未来恰当的 时机对任何免费服务内容收取相应的服务费用。
               和隆优化做出上述调整前会 以站内通知、邮件或官网公告等方式通知您，并给予您合理期限以完成数据的下载和备份。
             </p>
             <p>
                <strong> 1.4</strong>  您同意和隆优化为满足用户需求、提升产品使用体验等需要调整、升级和隆优化软件 提供的收费服务，包括服务种类、形式等。如因某些情况和隆优化需要终止 向您提供的收费服务，和隆优化将提前通过站内通知、邮件、官网公告等形式予以通知。
                <strong>您同意如果和隆优化终止提供某项收费服务，和隆优化的义务仅在于向您返还您尚未使用的服务期对应的部分费用。您同意和隆优化无需因收费服务的调整、升级或终止向您承担责任</strong> 。
                但无论如何，和隆优化将尽合理的努力给您预留合理的时间以便您为该等服务变更、中止或终止做出应对。
             </p>
             <p>
                <strong> 1.5</strong>  您在使用和隆优化软建服务前，应充分阅读并理解和隆优化官网对相应服务的描述，尤其是对免费服务、各级收费服务在功能、服务标准上的限制。<strong>对由于您未能充 分理解上述描述和限制而造成的任何损失，和隆优化不承担任何法律责任</strong> 。
             </p>
             <p>
                <strong> 1.6</strong> 和隆优化软件付费服务为收费的网络服务，您使用时需要向和隆优化支付一定的费用。<strong>对于和隆优化软件付费服务，我们会在您使用之前给予您明确的提示，只有您根据提示确认您愿意支付相关费用，您才能使用该等收费网络服务</strong> 。和隆优化软建付费服务具体内容以和隆优化根据实际情况提供，您可根据自己的需求选择适合的付费服务及付费级别，享受相应的服务；具体规则以和隆优化官网公示的内容为准。如您拒绝支付相关费用，则和隆优化有权不向您提供该等付费服务。
             </p>
             <h4>
                二、账户
             </h4>
             <p>
                <strong>2.1</strong>  为访问与使用和隆优化软件付费服务，您必须注册一个和隆优化账户。注册账户时，您需要提供真实、准确的信息。如果您的信息发生变更，请及时在您的账户中对信息进行 更新。您对（a）您的账户的保密性，以及用于启用您访问服务的任何密码、 身份验证密钥或安全凭据的安全性负责，和（b）所有在您账户下的活动， 不论是您还是您的最终用户的活动负责。如果您的账户下有任何未经授权或滥用行为或者任何与服务相关的安全事件，您将立即通知我们。<strong>您认可并同意我们不会对您账户中任何未经授权或滥用行为负责</strong> ，除非这是由我们违反本条款所造成的。 
             </p>
             <p>
                <strong>2.2</strong>  和隆优化和您应遵守相关法律法规进行实名认证。就和隆优化软件付费服务的使用，和隆优化可能要求您提供进一步的身份资料、经营资质和信息，以完成身份认证或资格验证。仅在完成相应身份认证及资格验证后，您才可以订购及使用相关服务。您理解并同意和隆优化有权自行或委托第三方，审查您在实名认证时提供的信息是否真实、准确及有效。您知晓并同意，如您未依照相关法律法规及和隆优化的要求完成实名认证，将影响您访问或使用本服务。
             </p>
             <p>
                <strong>2.3</strong>  您声明并保证，您向和隆优化提供的信息均为真实、准确、有效、最新的，否则您应承担由此产生的一切法律责任。尽管有前述规定，和隆优化无义务对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、准确性、完整性、适用性及/或是否为最新资料的责任。
             </p>
             <p>
                <strong>2.4</strong>  和隆优化建议您妥善保管您的注册邮箱、手机号、密码和名称，准确输入该等信息将作为您访问登录和隆优化软件服务并享有服务的关键环节。如果您发现有人未经授权使用您的账户信息或怀疑任何人未经授权可能能够访问您的私有内容，您应立即更改密码，并向我们反馈。
             </p>
             <h4>
                三、使用
             </h4>
             <h4 style="padding-bottom:0">3.1 订阅、退订与支付</h4>
             <p>
                <strong>3.1.1</strong> 和隆优化软建付费服务的具体内容及功能、服务标准、付费服务级别、服务期限、具体服务费用、费用组成等全部信息均以和隆优化官网公示为准，并会在您的订单页面列明。
                <strong>您在订阅和隆优化软件付费服务前应仔细阅读、充分理解并逐条确认和隆优化官网及您的订单页面中的上述信息，如因您的自身原因致使订阅发生错误或订阅的服务未能满足您的需求，和隆优化不因此承担任何法律责任。</strong>
             </p>
             <p>
                <strong>3.1.2</strong> 和隆优化为您提供了多种便捷的支付方式，具体以和隆优化官网公示为准，您可在上述支付方式中选择您偏好的方式进行支付。
             </p>
            <p>
                <strong>3.1.3</strong> 在您支付成功后，和隆优化才向您提供和隆优化软件付费服务，
                <strong>和隆优化在您未按照约定支付全部费用之前无义务向您提供任何服务和/或技术支持，但和隆优化官网公示的免费服务除外</strong>。
            </p>
            <p>
                <strong>3.1.4</strong> 在您支付成功后，您即享有相应服务<strong>自支付成功之日起30个自然日</strong>的 
试用期。在试用期内，您可随时联系我们要求退订相应服务。退订成功的，<strong>您仍应负担已使用和隆优化软件付费服务期间按日折算的服务费用</strong> ，尚未使用期间的服务费用将通过您订阅时的支付方式退回给您。若退款渠道发生变化，请您务必在退款前确保我们已知悉，否则由此产生的一切损失应由您自行承担。为免疑义，升级人数的订单不适用本条试用及退款的约定。
            </p>
            <p>
                <strong>3.1.5  若您超过试用期仍未申请退订，则和隆优化无任何义务向您返还任何价款。</strong>
            </p>
            <p>
                <strong>3.1.6  您完全理解和隆优化软件价格体系中所有的赠送服务项目或优惠活动均为和隆优化软件付费服务在正常服务价格之外的一次性特别优惠，赠送的服务项目或优惠活动不可折价、冲抵服务价格。</strong>
            </p>
           <p>
            <strong>3.2 您声明并保证您上传或储存在和隆优化软件付费服务中的内容不违反本条款并且符合法律法规。</strong>  您应对您的内容的合法性、准确性、完整性和可靠性负责。您应负责获得并持续保有任何与您的内容相关的通知、同意或授权。除非法律另有明确规定，否则和隆优化不承担任何与您的内容有关的义务和责任。
            <strong>若您在和隆优化软件付费服务上传、储存侵犯他人知识产权或其他违法、违规的内容，和隆优化有权利予以删除并保留移交司法机关处理的权利。</strong>
           </p>
           <p>
            <strong>3.3</strong> 您不得使用和隆优化软件付费服务上传、储存、共享、发送或传播任何敏感信息和违反国家法律法规的信息，包括但不限于下列信息：
           </p>
           <p>-反对宪法所确定的基本原则的</p>
           <p>-危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的</p>
           <p>-损害国家荣誉和利益的；</p>
           <p>-煽动民族仇恨、民族歧视，破坏民族团结的；</p>
           <p>-破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
           <p>-散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
           <p>-散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
           <p>-侮辱或者诽谤他人，侵害他人合法权益的；</p>
           <p>-含有法律、行政法规禁止的其他内容的。</p>
           <p>您承诺发表言论要：爱国、守法、自律、真实、文明。不传播任何非法的、 骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、 危害国家安全的、泄露国家机密的、破坏国家宗教政策和民族团结的以及其它违反法律法规及政策的内容。若您的行为不符合以上提到的服务条款和隆优化软件服务将作出独立判断立即暂停或终止用户的服务账号。用户需自行对其全部行为承担法律责任，和隆优化软件服务不承担任何法律责任。 </p>
           <p>
            <strong>3.4 您应当对您使用和隆优化软件付费服务的一切行为及所有在您账户下的活动，不论是您还是您授权的他人的活动负责。</strong>
            您不得利用和隆优化软件付费服务从事违反法律法规、违反本用户协议约定、危害网络安全、危害计算机系统安全、破坏和隆优化软件产品完整性或其他侵害和隆优化软件付费服务及任何第三人利益的活动。
            <strong>
                若您从事了上述行为，和隆优化有权暂停或终止您的账户，并拒绝您于现在和未来使用和隆优化软件付费服务之全部或任何部分，并无须承担任何返还付费服务价款义务，由此对和隆优化或第三人造成的损失或由此产生的一切法律责任均由您全部承担。
            </strong>
           </p>
            <h4>
                四、内容和知识产权 
            </h4>
            <p>
               <strong> 4.1</strong> 和隆优化对您在本服务提交的内容没有所有权，这些内容的所有权仍然归您所有。您明白和隆优化对您提供的任何内容不在任何方面负责或负有责任，和隆优化没有义务预先审查此类内容。但是，和隆优化软件付费服务有权随时决定内容是否合适和与本条款相符；如果发现此类内容违反本条款或在其他方面令人反感，和隆优化可随时并有绝对酌情权预先审查、转移、拒绝、修改和/或删除内容，而不需事先通知。用户使用本服务的行为若有任何违反国家法律法规或侵犯任何第三方合法权益的情形，和隆优化有权直接删除该等违反规定的信息，并可以暂停或终止向该用户提供服务。
            </p>
            <p>
                <strong>4.2</strong> 本服务的所有权及所有相关的知识产权（包括但不限于源代码、目标代码、文档资料、界面设计、版面框架、以及任何由和隆优化根据维护与技术支持提供的软件、资料等）归和隆优化所有。您认同和隆优化拥有的所有权及知识产权，并承诺尊重及不以任何方式侵害和隆优化的所有权及知识产权。未经和隆优化书面许可，您不能复制、拷贝转让、许可或提供他人使用上述知识成果，或者重用任何部分代码和外观设计，否则您应承担相应的法律责任，
                <strong>且和隆优化有权终止您对和隆优化软件付费服务的使用且不退还任何费用。</strong>
            </p>
            <h4>
                五、 隐私政策 
            </h4>
            <p>
              <strong>5.1</strong> 使用本服务，即表示您同意和隆优化合法收集和使用有关您及您所使用本服务的技术性或诊断性信息。手机端可能会用到录音、拍照、读取相册等权限， 仅在用于用户反馈建议和问题时调用。收集到的这些信息将用于改进和隆优化软件服务的内容和技术，提升我们的服务品质。和隆优化不会将您的信息和内容分享或出售给其他的组织。但以下情况除外：
            </p>
            <p>-事先获得您的明确授权； </p>
            <p>-事先获得您的明确授权； </p>
            <p>-遵守法院命令或其他法律程序的规定；</p>
            <p>-遵守相关政府主管部门的要求；</p>
            <p>-与国家安全、国防安全、公共安全、公共卫生、公共利益直接相关的；-从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</p>
            <p>-和隆优化认为为遵守适用的法律法规、维护社会公共利益、或保护和隆优化的客户、其他用户或雇员的人身和财产安全或合法权益所合理必需的； </p>
            <p>-您违反了本服务条款，且和隆优化出于维权需要向第三方提供的； </p>
            <p>-法律法规规定的其他情形。</p>
            <p>
               <strong>5.2</strong> 保护用户个人信息是和隆优化的一项基本原则，
               <strong>和隆优化将按照《和隆优化隐私政策》约定收集、使用、储存和分享您的个人信息。您声明并保证，已仔细 阅读、完全理解并同意上述《和隆优化隐私政策》的全部内容。您对本条款的接 受将视为您对《和隆优化隐私政策》的接受、充分理解和同意，若您不同意本条款及《和隆优化隐私政策》，请您立即停止使用我们提供的任何服务或产品，若您继续使用，则视为您已同意本条款及《和隆优化隐私政策》。</strong>
            </p>
           <h4>六、数据和信息安全</h4>
           <p>
            <strong>6.1 和隆优化将依照法律、行政法规的规定和国家标准的强制性要求，采取合理的技术措施和其他必要措施，努力保护您的信息安全。但是，互联网数据传输、存储、转换均可能存在一定未知且不确定的数据安全风险，该等风险将导致包括但不限于数据丢失、泄露、损坏、无法读取或提取等后果。您确认，您已明确知晓并同意接受该等因互联网引发的风险和后果，并已采取恰当的措施（例如数据备份等），以便在该等风险发生时将损失降至最低。</strong>
           </p>
           <p>
            <strong>6.2 因互联网技术本身等非和隆优化原因导致危害您数据安全，导致您的数据丢失或损坏或商业利益损失的，和隆优化不承担任何赔偿责任。因和隆优化重大过失造成危害您数据安全的，和隆优化对您承担的赔偿责任以向您收取的服务费用为上限。</strong>
           </p>
           <p>
            <strong>6.3</strong>  您可自行对您上传、储存在和隆优化软件付费服务中的数据进行删除、更改等操作。就数据的删除、更改等操作，您应谨慎操作。当付费服务期届满、服务提前终止（包括账户注销或其他原因导致的提前终止等）或付费用户发生欠费时，除法律法规明确规定、主管部门要求或双方另有约定外，和隆优化软件付费服务仅在一定的缓冲期（以您所订购的服务适用的专有条款、产品文档、服务说明等所载明的时限为准）内继续存储您的数据（如有），缓冲期届满和隆优化将删除所有用户业务数据，包括所有缓存或者备份的副本，不再保留您的任何数据
            <strong>用户业务数据一经删除，即不可恢复；您应承担数据因此被删除所引发的后果和责任，您理解并同意，和隆优化没有继续保留、导出或者返还用户业务数据的义务。</strong>
           </p>
           <h4>七、免责声明</h4>
           <p>
            <strong>7.1 您知悉并同意，下列情况下，和隆优化无需向您承担任何责任：</strong>
           </p>
           <p>
            <strong>7.1 由于您维护不当或保密不当，导致数据、资料、口令、密码等丢失或泄漏，或其他非因和隆优化原因导致的个人信息的泄漏，和隆优化不承担任何法律责任；</strong>
           </p>
           <p>
            <strong>
                7.2 任何由于不可抗力、黑客攻击、电脑病毒侵入、网络运营商原因或政府管制等和隆优化无法合理控制的原因而造成和隆优化软件服务使用中止、中断、延误、使用限制、使用异常、使用不能、暂时性网站关闭等，和隆优化不承担任何法律责任；
            </strong>
           </p>
           <p>
            <strong>
                7.3 您应对通过和隆优化软件付费服务上传或储存文件、输入数据的合法性以及获得文件、数据、内容的方式的合法性负责，因上述文件、数据、内容引发的一切纠纷，由您承担全部法律责任，和隆优化不承担任何法律责任；
            </strong>
           </p>
           <p>
            <strong>
                7.4 互联网是一个开放平台，如果您将图片、文字等内容上传并传播，有可能会被其他组织或个人复制、转载、擅改或做其它非法用途，您应充分意识到此类风险的存在。您同意使用和隆优化服务所存在的此类风险及后果将完全由您自己承担，和隆优化不承担任何责任。
            </strong>
           </p>
           <p>
            <strong>
                7.5 您理解并确认，受技术所限，和隆优化无法保证其所提供的服务毫无瑕疵，但我们承诺将不断提升服务质量及服务水平，为您提供更加优质的服务。据此，您同意：如果和隆优化所提供的服务虽然存在瑕疵，但该等瑕疵是当时行业技术水平所无法避免的，其将不被视为违约，和隆优化无须因此向您承担任何责任。 
            </strong>
           </p>
           <h4>
            八、服务变更/中断/终止
           </h4>
           <p>
            <strong>8.1</strong>
            您可随时注销您的账户并停止使用和隆优化软件付费服务。注销账户的方式可遵照和隆优化官网的指引。您声明并保证，在您自主注销账户前已经将您上传、储存在和隆优化软件付费服务中的数据下载、备份完毕。
            <strong>您自主注销账户后，和隆优化软件付费服务将不再保留您的数据。 </strong>
           </p>
            <p>
                <strong>
                    8.2 若您注销账户时，您订阅的和隆优化软件付费服务的服务期限尚未届至，您可按照本条款 3.1.4 条之约定并务必在注销账户前申请退订和退款。若您未申请退订和退款即注销账户或您按照本条款 3.1.5 条、3.1.6 条之约定不享有退款权利的，则您注销账户的行为即视为您对要求和隆优化提供付费服务权利的完全、无对价且不可撤销的放弃，和隆优化不再对您承担任何价款返还或损害赔偿义务。
                </strong>
            </p>
            <p>
                <strong>8.3</strong>  您理解并同意，如因系统维护或升级的需要而暂停和隆优化软件付费服务、调整服务功能的，和隆优化将尽可能事先在网站上进行通告，<strong>但不因此承担任何法律责任</strong> 。
            </p> 
            <p> <strong>8.4</strong>  和隆优化可随时在如下情况下，不需事先通知，立即终止或暂停您所有或部分账户和/或本服务之进入；
            <strong>若是您存在主观故意或重大过失的情况，则和隆优化无须向您退还任何订阅价款：</strong>
            </p>
            <p>-您提供的资料不真实，或违反其他用户个人资料提供规则；</p>
            <p>-您违反法律法规、本条款或您与和隆优化的其他约定；</p>
            <p>-您要求取消或终止您的账户；</p>
            <p>-未经和隆优化同意，将和隆优化软件产品本身用于商业目的；</p>
            <p>-您对和隆优化软件付费服务的访问或使用可能会对和隆优化软件服务、和隆优化或第三方造成安全风险；</p>
            <p>-需要听从法庭传票、法律命令或遵循法律程序； </p>
            <p>-根据相关法律法规或政府机构的要求；</p>
            <p>-根据相关法律法规或政府机构的要求</p>
            <p>-本条款发生变更或修改，您不同意变更或修改后的用户条款。</p>
            <p>
                <strong>8.5</strong>  您理解并认可，为技术升级、服务体系升级、或因经营策略调整或配合国家重大技术、法规政策等变化，
                <strong>和隆优化不保证永久的提供某种服务，或可能变更所提供服务的形式、规格或其他方面，</strong>
                在终止该种服务或进行此种变更前，和隆优化将尽最大努力且提前以网站公告、站内信、邮件或短信等一种或多种方式进行事先通知；如终止提供该种服务的，和隆优化将尽合理的努力给您预留合理的时间，妥善处理后续事宜。
            </p>
            <p>由于本 <strong>8.5 </strong> 条原因致使终止对您提供已订阅的和隆优化软件付费服务的，和隆优化应根据您服务期限内的剩余时间按天数折算返还您支付的价款。 </p>
            <p>
                <strong>8.6</strong>
                ⼀旦您的账户被终止，您将无法正常使用本服务。此外，您可以选择删除您的账户下的所有信息和内容.
            </p>
            <h4>
                九、本服务条款的完善和修改
            </h4>
            <p>
                <strong>9.1</strong>  和隆优化有权根据互联网的发展和中华人民共和国有关法律、法规的变化，不时地完善和修改本条款。和隆优化保留随时修改本条款的权利，并会将修改后的服务条款在和隆优化官网上公布，该等公布视为对您的有效通知送达。
                <strong>您在使用和隆优化的服务时，有必要对最新的《和隆优化软件付费版服务条款》进行仔细阅读和重新确认，当发生相关争议时，以最新的服务条款为准。</strong>
            </p>
            <p>
                <strong>9.2</strong>  如果您不同意和隆优化对本条款所做的修改，您应立即停止使用和隆优化软件付费服务。 <strong>如果用户继续使用和隆优化软件付费服务，则视为用户接受我方对本条款所做的修改。</strong>
            </p>
            <h4>
                十、青少年特别条款 
            </h4>
            <p>
                <strong>10.1</strong>  和隆优化软件付费服务主要面向成年人。若您是未成年人，<strong>请您确保您的监护人已仔细阅读、理解并接受本条款。并在征得您的监护人同意的前提下使用和隆优化软件付费服务或向和隆优化提供信息。 </strong>
            </p>
            <p>
                <strong>10.2</strong>  如您的监护人不同意您按照本条款使用和隆优化软件付费服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。
            </p>
            <p> 
                <strong>10.3</strong>  您声明并保证，您是具有完全民事行为能力的自然人。若您违背上述保证购买、使用和隆优化软件付费服务的，和隆优化不因此承担任何包括但不限于返还价款在内的任何法律责任，由此造成的损失应由您或您的监护人自行承担。
            </p>
            <h4>
                十一、法律适用及争议解决 
            </h4>
            <p>
                <strong>11.1</strong>  本条款之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆法律；如法律无相关规定的，参照商业惯例及/或行业惯例。
            </p>
            <p>
                <strong>11.2</strong>  您因使用和隆优化软件付费服务所产生及与本条款有关的一切争议，由和隆优化与您协商解决。协商不成时，任何一方均可向和隆优化住所地人民法院提起诉讼。
            </p>
            <p>
                <strong>11.3</strong>  若用户利用本服务从事任何违法或侵权行为，由用户自行承担全部责任，和隆优化不承担任何法律责任。因此给和隆优化或任何第三方造成任何损失的，用户应负责全额赔偿。
            </p>
            <h4>
                十二、与我们联系
            </h4>
            <p>
                当您有其他的投诉、建议或反馈时，请与我们联系。您可以拨打电话：400-8811-519 ，或邮寄到如下地址：北京市海淀区北清路81号中关村壹号B1座8F 北京和隆优化信息技术有限公司产品运营（收），邮编：100096
            </p>
            <h4>
                十三、其他条款
            </h4>
            <p>
                <strong>13.1 和隆优化有权不经过您的事先单独同意，将本条款的权利义务全部或者部分转移给和隆优化的关联公司，但和隆优化保证不会实质性降低您可获得服务的质量。</strong> 
            </p>
            <p>
                <strong>13.2</strong> 未经和隆优化事先同意，您不得将本条款项下的任何权利义务转让给第三人。
            </p>
            <p>
                <strong>13.3</strong>   本条款部分条款因任何原因被宣告无效或不可履行的，不影响其他条款的效力，其他条款仍应继续适用。任何无效或不可履行的条款将被替换为与本协议目的和意图一致的另一条款。
            </p>
            <p>
                <strong>13.4</strong>  因超出和隆优化合理控制的情况致使和隆优化未能遵守所有条款和条件，则和隆优化对这类不履约概不承担任何责任。
            </p>
            <p>
                <strong>13.5</strong>  和隆优化可通过站内消息或您在注册账户、使用和隆优化软件服务过程中提供的电话、电子邮件或其他联系方式向您发出通知。上述通知一经发出即视为对您产生效力，<strong>您有义务保证您的联系方式的有效性。</strong>
            </p>
            <p>
                <strong>13.6</strong>  除非和隆优化以书面方式确认并同意，和隆优化未履行本条款中任何权利或条款的行为不构成和隆优化对相关权利或条款的放弃。
            </p>
            <p>
                <strong>13.7</strong>  最近修订于 2023 年 01 月 03 日。和隆优化保留一切权利。
               



            </p>
            <h4>北京和隆优化科技股份有限公司</h4>
           </div>
    </div>
</template>
<script>
export default {
    name:'Agreement',
    data() {
        return {
            
        }
    },
    created() {
        this.$route.query.type == 1 ? document.title = "和隆优化-用户协议" : this.$route.query.type == 2 ? document.title = "和隆优化-隐私政策"  : document.title = "和隆优化-付费服务条款" 
    },
    methods: {
        openAg(){
            this.$router.push({
                name:'Agreement',
                query:{
                    type:2
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
#Agreement{
        overflow-y: auto;
    height: 100vh;
}
.AgreementType1{
    width: 80%;
    margin: 0 auto;
    padding: 100px 0;
    h1{
        text-align: center;
        font-size: 40px;
        padding-bottom: 50px;
    }
    .tit{
        padding-bottom: 50px;
    }
    .tit1{
       line-height: 40px; 
        padding-bottom: 50px;
    }
    h4{
        padding-bottom: 30px;
    }
    .h4text{
        line-height: 40px;
    }
    p{
        padding-bottom: 10px;
        line-height: 40px;
    }
}
</style>